import { FormEvent } from 'react';

export const sortingOptions = (t: Function) => [
  { label: t('sort.default', { ns: 'common' }), value: '' },
  { label: t('sort.device-id', { ns: 'common' }), value: 'device_id' },
];

export interface SelectOption {
  label: string;
  id: string;
  value: string;
}

export enum DialogType {
  Add = 'Add',
  Edit = 'Edit',
  Delete = 'Delete',
}

export interface DialogConfig {
  title: string;
  subtitle?: string;
  note?: string;
  fields: DialogField[];
}

export interface DialogField {
  label: string;
  type?: string;
  name: string;
  value?: string;
  isRequired?: boolean;
  readOnly?: boolean;
  options?: SelectOption[];
  /**
   * EV-116（照合の懸念4）。日付・時刻の組の時刻の欄の、元の時刻（UTC の ISO 文字列）。編集の画面は、
   * 元の値を変えていなければ元の時刻で前後を比べ、2回ある時刻の案内を出さない。
   */
  originalIso?: string | null;
  /**
   * EV-322（ADM-15）。この欄の選択肢を読めなかったときの失敗。欄の下に既存の FetchFailed の文言と失敗の種類を
   * 注記（role="alert"）で出し、欄と aria-describedby で結ぶ。onRetry で選択肢を読み直す。
   */
  fetchError?: unknown;
  onRetry?: () => void;
}

export interface DialogProps {
  isOpen: boolean;
  onClose: () => void;
  handleSubmit: (
    e: FormEvent<Element>,
    newData: NewDataField & { id: string }
  ) => Promise<void>;
  title: string;
  subtitle: string;
  note?: string;
  fields: DialogField[];
  deviceId?: string;
  attendanceId?: string;
  vehicleId?: string;
  taskSessionId?: string;
  confirmLabel?: string;
  cancelLabel?: string;
}

export interface NewDataField {
  id: string;
  [key: string]: string | number | null;
}

export const createTextField = (
  label: string,
  name: string,
  isRequired: boolean,
  value: string,
  readOnly?: boolean
): DialogField => ({
  label,
  type: 'text',
  name,
  isRequired,
  value,
  readOnly,
});

export const createSelectField = (
  label: string,
  name: string,
  isRequired: boolean,
  value: string,
  readOnly?: boolean
): DialogField => ({
  label,
  type: 'select',
  name,
  isRequired,
  value,
  readOnly,
});

export const createDateField = (
  label: string,
  name: string,
  isRequired: boolean,
  value: string,
  readOnly?: boolean
): DialogField => ({
  label,
  type: 'date',
  name,
  isRequired,
  value,
  readOnly,
});

export const createTimeField = (
  label: string,
  name: string,
  isRequired: boolean,
  value: string,
  readOnly?: boolean
): DialogField => ({
  label,
  type: 'time',
  name,
  isRequired,
  value,
  readOnly,
});

/** BE-09-AC5。勤怠・作業の修正の理由の欄の種類（DialogField.type）と、サーバーの上限の文字数。 */
export const REASON_FIELD_TYPE = 'reason';
export const REASON_MAX_LENGTH = 500;
